export const FAT_ORIGIN = 'https://fat.quectel.com.cn'
// 临时线上认证联调；测试结束将开关改回 false 即恢复原 FAT 配置。
const USE_PRODUCTION_AUTH_FOR_TEST = true
export const FAT_AUTH_ORIGIN = USE_PRODUCTION_AUTH_FOR_TEST
  ? 'https://auth.quectel.com.cn'
  : 'https://fat-auth.quecinfo.com'
export const FAT_CLIENT_ID = USE_PRODUCTION_AUTH_FOR_TEST
  ? 'e3c911a40dbc40619bbc1cf9796e536b'
  : '8c29a833009246a899655a4f24b597cd'
export const QAUTH_POOL_CODE = 'EXTUP'
export const OAUTH_PENDING_KEY = 'quecai-oauth-pending'
export const OAUTH_CALLBACK_PATH = '/ai-open-platform/auth/callback'

// 回调必须留在发起登录的站点，否则 sessionStorage 中的 state 无法读取。
const OAUTH_SITE_ORIGINS = [
  FAT_ORIGIN,
  'https://www.quectel.com.cn',
  'https://quectel.com.cn',
]

export function getOAuthSiteOrigin(value = window.location.origin) {
  const url = new URL(value)
  const localHost = ['localhost', '127.0.0.1', 'quecai-v3.quec.com'].includes(
    url.hostname,
  )
  if (
    (!OAUTH_SITE_ORIGINS.includes(url.origin) && !(localHost && url.protocol === 'http:')) ||
    url.username ||
    url.password
  ) {
    throw new Error('登录前页面地址无效')
  }
  return url.origin
}

export function getOAuthCallbackUrl() {
  return new URL(OAUTH_CALLBACK_PATH, getOAuthSiteOrigin()).href
}

export function getOAuthReturnUrl(value, expectedOrigin) {
  const url = new URL(value)
  const origin = getOAuthSiteOrigin(value)
  if (
    (expectedOrigin && origin !== getOAuthSiteOrigin(expectedOrigin)) ||
    /^\/ai-open-platform\/auth\/(?:start|callback)\/?$/.test(url.pathname)
  ) {
    throw new Error('登录前页面地址无效')
  }
  url.searchParams.delete('code')
  url.searchParams.delete('state')
  return url
}
